export default "__VITE_ASSET__CSQ7GCIn__"